import * as t from 'io-ts';
import { createGuard } from 'src_common/common/createGuard';

const ParamsIO = t.interface({
    data: t.interface({
        display: t.boolean,
        active: t.boolean,
        name: t.string,
    }),
    id: t.number,
});

const isParams = createGuard(ParamsIO);

export const competitionsSaveCall = async (params: unknown): Promise<void> => {
    if (!isParams(params)) {
        console.error('competitionsSaveCall: incorrect parameters', params);
        return;
    }

    const competitionId = $appState.sdkStaff.models.id.getCompetitionId(params.id);
    const competition = await competitionId.getModelAsync();
    const idV2 = await competitionId.idv2();

    await $appState.sdkStaff.patchCompetition({
        sport_id: competition.getData().sport,
        competition_id: params.id,
        requestBody: {
            idV2,
            display: params.data.display,
            active: params.data.active,
            name: params.data.name
        }
    });
};

